import { BaseError } from '../../helpers/errors/BaseError';
import { SafeLogErrorOptions } from '../../helpers/log-error';

export class SettingsTimeoutError extends BaseError {
    constructor(loggerFields: SafeLogErrorOptions) {
        super("Couldn't wait for user settings to be initialized", loggerFields);

        Object.setPrototypeOf(this, SettingsTimeoutError.prototype);
    }
}
